import { createFileRoute, redirect } from '@tanstack/react-router';
import { OrderManagementPage } from '../components/OrderManagementPage';
import { orderService } from '../services/orderService';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/settings/orders')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdmin(user?.role)) {
      throw redirect({ to: '/project-settings/employee-project-models' });
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context;
    await queryClient.prefetchQuery({
      queryKey: ['orders'],
      queryFn: () => orderService.getOrders(),
      staleTime: 1000 * 60 * 5,
    });
  },
  component: SettingsOrdersComponent,
});

function SettingsOrdersComponent() {
  return <OrderManagementPage />;
}
